<template>
  <v-menu bottom left>
    <template #activator="{ on, attrs }">
      <v-btn dark icon v-bind="attrs" small @click="launchStep" v-on="on">
        <v-badge
          :value="badgeValue"
          color="red"
          offset-x="10px"
          offset-y="10px"
        >
          <template #badge>
            <v-progress-circular
              v-if="loadingReminders"
              indeterminate
              color="white"
              size="8"
              width="2"
              style="transform: translateY(-1px)"
            />
            <span v-else>{{ remindersCountString }}</span>
          </template>

          <v-img
            width="25px"
            height="25px"
            contain
            src="@/assets/img/navbar_icons/backorder-icon.svg"
          />
        </v-badge>
      </v-btn>
    </template>

    <v-card v-if="loadingReminders">
      <v-card-text> Cargando recordatorios... </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
  import { mapGetters, mapActions, mapMutations } from 'vuex';

  export default {
    name: 'ReminderStepLauncher',

    data() {
      return {
        intervalId: null,
        showEvery: 15 * 60 * 1000,
      };
    },
    computed: {
      ...mapGetters('reminders', [
        'hasAvailableReminders',
        'availableRemindersCount',
        'loadingReminders',
      ]),

      remindersCountString() {
        return this.availableRemindersCount !== null &&
          this.availableRemindersCount !== undefined
          ? this.availableRemindersCount.toString()
          : '0';
      },

      badgeValue() {
        // If availableRemindersCount is 0, the badge stays hidden — so during loading, the loader isn't shown either.
        if (this.loadingReminders) return 1;
        return this.availableRemindersCount;
      },
    },
    mounted() {
      this.intervalId = setInterval(async () => {
        await this.loadRemindersStep();
      }, this.showEvery);
    },
    beforeDestroy() {
      clearInterval(this.intervalId);
      this.intervalId = null;
    },
    methods: {
      ...mapMutations('modalStepsAfterLogin', [
        'ADD_STEP',
        'REMOVE_STEP',
        'REMOVE_STEPS_BY_PREFIX',
      ]),
      ...mapActions('modalStepsAfterLogin', [
        'updateModalState',
        'findStepByKey',
        'changeCurrentStepValue',
        'updateStepStatus',
        'loadRemindersStep',
      ]),
      // This method is used instead of $store.loadRemindersStep to always add the step and skip the hasAvailableReminders validation
      showRemindersStep() {
        this.ADD_STEP({
          key: 'reminders',
          text: 'Backorders',
          doneRequired: false,
        });

        this.REMOVE_STEP('notifications');
        this.REMOVE_STEP('notificationPreview');
        this.REMOVE_STEP('updateData');
        this.REMOVE_STEP('updatePassword');
        this.REMOVE_STEP('shoppingCartAlerts');
        this.REMOVE_STEP('billingModuleStatus');
        this.REMOVE_STEP('recentOrders');
        this.REMOVE_STEPS_BY_PREFIX('scheduleEventConfirmation');
      },
      async launchStep() {
        this.showRemindersStep();
        const reminderStep = await this.findStepByKey('reminders');

        if (reminderStep) {
          reminderStep.visited = true;
          this.updateStepStatus(reminderStep);
          this.changeCurrentStepValue(reminderStep.value);
          this.updateModalState(true);
        }
      },
    },
  };
</script>
